// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1flQm","title":"Header_title__3DBDp","left":"Header_left__2CnjR","clinicName":"Header_clinicName___s7WC"};